import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

// const API_BASE = "http://127.0.0.1:8000";
// const API_BASE = "http://10.0.0.72:8000";
// const API_BASE = "http://localhost:8000";
// const API_BASE = `http://${window.location.hostname}:8000`;
const API_BASE = process.env.REACT_APP_API_URL;
// const API_BASE = 'https://spradley-website.onrender.com';

export function createJsonApiHooks(collection) {
  const baseUrl = `${API_BASE}/${collection}`;

  function useAll() {
    return useQuery({
      queryKey: [collection],
      queryFn: () =>
        fetch(baseUrl).then((res) => {
          if (!res.ok) throw new Error(`Failed to load ${collection}`);
          return res.json();
        }),
    });
  }

  function useOne(id) {
    return useQuery({
      queryKey: [collection, id],
      queryFn: () =>
        fetch(`${baseUrl}/${id}`).then((res) => {
          if (!res.ok) throw new Error(`${collection} item not found`);
          return res.json();
        }),
      enabled: !!id,
    });
  }

  function useAdd() {
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: async ({ id, data }) => {
        const res = await fetch(`${baseUrl}/${id}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (!res.ok) {
          const msg = await res.json();
          throw new Error(msg.detail || `Failed to add ${collection} item`);
        }

        return res.json();
      },

      onSuccess: () => {
        queryClient.invalidateQueries([collection]);
      },
    });
  }

  function useUpdate() {
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: async ({ id, data }) => {
        const res = await fetch(`${baseUrl}/${id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (!res.ok) {
          const msg = await res.json();
          throw new Error(msg.detail || `Failed to update ${collection} item`);
        }

        return res.json();
      },

      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries({
          queryKey: [collection],
        });

        queryClient.invalidateQueries({
          queryKey: [collection, id],
        });
      },
    });
  }

  function useDelete() {
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: async (id) => {
        const res = await fetch(`${baseUrl}/${id}`, {
          method: "DELETE",
        });

        if (!res.ok) {
          const msg = await res.json();
          throw new Error(msg.detail || `Failed to delete ${collection} item`);
        }

        return res.json();
      },

      onSuccess: (_, id) => {
        queryClient.invalidateQueries([collection]);
        queryClient.removeQueries([collection, id]);
      },
    });
  }

  return { useAll, useOne, useAdd, useUpdate, useDelete };
}
